import { Theme } from '@material-ui/core';
import { COMPONENT_CLASSES } from '#web-components/components/Form/constants';

const contentSelector = `.${COMPONENT_CLASSES.content}`;

export const createContentStyles = ({ colors, typography, spacing }: Theme) => ({
  [contentSelector]: {
    wordBreak: 'break-word',
    '& .ck-toolbar__items': {
      '& .ck-button': {
        '&:nth-of-type(1)': {
          display: 'none',
        },
        '&:nth-of-type(2)': {
          display: 'none',
        },
        '&:nth-of-type(6)': {
          display: 'none',
        },
        '&:nth-of-type(7)': {
          display: 'none',
        },
        '&:nth-of-type(8)': {
          display: 'none',
        },
        '&:nth-of-type(9)': {
          display: 'none',
        },
        '&:nth-of-type(10)': {
          display: 'none',
        },
        '&:nth-of-type(11)': {
          display: 'none',
        },
      },

      '& span.ck-toolbar__separator': {
        '&:nth-of-type(2)': {
          display: 'none',
        },
      },

      '& .ck-font-family-dropdown': {
        '& .ck-font-size-dropdown': {
          display: 'none',
        },
      },

      '& .ck-heading-dropdown button.ck-button': {
        display: 'inline-block',
      },
    },
    '& p': {
      ...typography.textRegular,
    },
    '& li': {
      ...typography.textRegular,
    },
    '& h2': {
      ...typography.h2,
    },
    '& h3': {
      ...typography.h3,
    },
    '& h4': {
      ...typography.h4,
    },
  },
  '.formbuilder': {
    '& .mdtuddm-content': {
      border: `2px dashed ${colors.base.grey500}`,
    },
  },
  '& div.ck.ck-content': {
    minHeight: spacing(18),
  },
});
